import { render } from "./VisibleText.vue?vue&type=template&id=3869c1ce"
import script from "./VisibleText.vue?vue&type=script&lang=js"
export * from "./VisibleText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__